import { render, staticRenderFns } from "./richwater.vue?vue&type=template&id=1ed6ddd1"
import script from "./richwater.vue?vue&type=script&lang=js"
export * from "./richwater.vue?vue&type=script&lang=js"
import style0 from "./richwater.vue?vue&type=style&index=0&id=1ed6ddd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports